import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PipesModule } from '../../pipes/pipes.module';
import { LoadingIndicatorComponent } from './loading-indicator.component';
import { SpinnerComponent } from './spinner.component';
import { LoadingIndicatorPanelComponent } from './loading-indicator-panel.component';

@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    SpinnerComponent,
    LoadingIndicatorComponent,
    LoadingIndicatorPanelComponent
  ],
  exports: [
    SpinnerComponent,
    LoadingIndicatorComponent,
    LoadingIndicatorPanelComponent
  ]
})
export class LoadingIndicatorModule {
}
